/**
 * Lista pre-definida de cargos comuns em empresas de tecnologia.
 * Usada nos formularios de cadastro/perfil como sugestoes (Autocomplete).
 * User ainda pode digitar valor livre fora da lista.
 */
export const JOB_TITLES_TECH: readonly string[] = [
  // Engenharia de Software
  'Desenvolvedor(a) Front-end',
  'Desenvolvedor(a) Back-end',
  'Desenvolvedor(a) Full-stack',
  'Desenvolvedor(a) Mobile',
  'Engenheiro(a) de Software',
  'Engenheiro(a) de Dados',
  'Engenheiro(a) de Machine Learning',
  'Engenheiro(a) DevOps',
  'Engenheiro(a) SRE',
  'Engenheiro(a) de Plataforma',
  'Engenheiro(a) de QA',
  'Tech Lead',
  'Arquiteto(a) de Software',
  'Arquiteto(a) de Solucoes',

  // Dados / IA
  'Analista de Dados',
  'Cientista de Dados',
  'Analista de BI',
  'Engenheiro(a) de IA',

  // Produto / Design
  'Product Manager',
  'Product Owner',
  'Designer UX/UI',
  'Designer Visual',
  'Pesquisador(a) UX',
  'Analista de Negocios',

  // Seguranca
  'Analista de Segurança da Informação',
  'Engenheiro(a) de Segurança',
  'Pentester',
  'CISO',

  // Infra / Suporte
  'Administrador(a) de Sistemas',
  'Administrador(a) de Banco de Dados',
  'Analista de Infraestrutura',
  'Analista de Suporte',
  'Analista de Redes',
  'Técnico(a) de TI',

  // Gestao
  'CTO',
  'CEO',
  'VP de Engenharia',
  'Diretor(a) de Tecnologia',
  'Gerente de Engenharia',
  'Gerente de Projetos',
  'Coordenador(a) de TI',
  'Líder Técnico',
  'Scrum Master',
  'Agile Coach',

  // Outros
  'Estagiario(a)',
  'Trainee',
  'Consultor(a) de TI',
] as const
